export default "__VITE_ASSET__58afdf3f__"